import Axios, {AxiosResponse} from "axios";
import {IOrderRequestDto} from "../models/order/order";
import RootApi from "./root-api";

export default class OrderApi extends RootApi {
    private readonly apiEndpoint: string = `${this.ApiRoot}/orders`;

    public async createOrder(request: IOrderRequestDto): Promise<AxiosResponse> {
        return await Axios.post(`${this.apiEndpoint}/create`, request);
    }

    public async getOrderByCode(code: string): Promise<AxiosResponse> {
        const token = document.cookie.replace(/(?:(?:^|.*;\s*)order-token\s*=\s*([^;]*).*$)|^.*$/, "$1");
        return await Axios.get(`${this.apiEndpoint}/${code}`, {headers: {Authorization: `Bearer ${token}`}});
    }

    public async getOrderTotal(code: string): Promise<AxiosResponse> {
        return await Axios.get(`${this.apiEndpoint}/${code}/total`);
    }
}



// WEBPACK FOOTER //
// ./src/api/order-api.ts